import React, { useEffect } from "react";
import { useApi } from "../../hooks/useApi";
import { Teacher } from "../../types/teacher";
import { toast } from "react-hot-toast";

const TeachersTable: React.FC = () => {
  const {
    data: teachers,
    loading,
    error,
    fetchData,
  } = useApi<Teacher[]>("/api/teachers");

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDelete = async (id: string) => {
    try {
      await fetch(`/api/teachers/${id}`, { method: "DELETE" });
      toast.success("Teacher deleted successfully");
      fetchData(); // Refresh the table after deletion
    } catch (err) {
      toast.error("Failed to delete teacher");
    }
  };

  if (loading) return <div className="loading-spinner" />;
  if (error) return <div className="text-red-500">Error loading teachers</div>;

  return (
    <div className="overflow-x-auto bg-white rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:-translate-y-1 border-0">
      <table className="min-w-full bg-white">
        <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
          <tr>
            <th className="py-4 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Name
            </th>
            <th className="py-4 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Email
            </th>
            <th className="py-4 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {teachers.map((teacher, index: number) => (
            <tr
              key={teacher._id}
              className={`${
                index % 2 === 0 ? "bg-white" : "bg-gray-50/30"
              } hover:bg-blue-50/50 transition-colors duration-200`}
            >
              <td className="py-4 px-6">
                {teacher.firstName} {teacher.lastName}
              </td>
              <td className="py-4 px-6">{teacher.email}</td>
              <td className="py-4 px-6">
                <button
                  className="inline-flex items-center p-2 rounded-lg shadow-md hover:shadow-lg text-blue-600 hover:text-blue-700 hover:bg-blue-50 transition-all duration-200 border-0"
                  onClick={() => {
                    /* Navigate to edit */
                  }}
                >
                  Edit
                </button>
                <button
                  className="text-red-500 hover:underline ml-4"
                  onClick={() => handleDelete(teacher._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TeachersTable;
